import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SystemMessageType } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseQueryOptions<unknown, Error, SystemMessageType[]>,
    'queryKey' | 'queryFn'
  >;
}

export const useMessageTypeListRequest = ({
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, SystemMessageType[]>(
    [Entities.SystemMessageTypes],
    async () => {
      const { data } = await api.v1AdminSystemMessagesTypesGet()
      return data
    },
    {
      ...options,
    },
  )
}
